import React from "react";
import { Layout, Typography } from "antd";
const { Title } = Typography;
const { Header, Footer, Sider, Content } = Layout;
export default function JudgeLayout(props) {
  return (
    <Layout style={{ width: "100vw", height: "100vh" }}>
      <Header className="site-layout-background">
        <div
          style={{
            display: "flex",
            alignItems: "baseline",
            alignContent: "center",
            paddingTop: "5px",
            background: "white",
            color: "black",
          }}
        >
          {" "}
          <Title level={4}>BIG APPLE STARS AWARDS ONLINE JUDGE</Title>
        </div>
      </Header>
      <Layout>
        <Sider
          className="site-layout-background"
          width={props.sidebar ? 250 : 0}
        >
          <div style={{ padding: "2rem 3rem" }}>{props.sidebar}</div>
        </Sider>
        <Content
          className="site-layout-background"
          style={{ paddingBottom: "2rem" }}
        >
          <div
            style={{
              minHeight: "80vh",
              padding: "2rem 2rem 4rem 2rem ",
              marginBottom: "50px",
            }}
          >
            {props.children}
          </div>
        </Content>
      </Layout>
      <Footer
        style={{
          textAlign: "center",
          padding: 9,
          height: "40px",
          bottom: 0,
          width: "100%",
          position: "fixed",
        }}
      >
        ©2022 Hotel Association of New York City
      </Footer>
    </Layout>
  );
}
